module.exports = __webpack_public_path__ + "img/fw_icon.50272238.png";